import { useEffect, useRef, useState } from "react";
import { useAlert } from "../../hooks";
import constants from "../../utils/constants";
import { verifyFileTypeForUpload } from "../../utils/helpers";
import { DocumentArrowUpIcon, XMarkIcon } from "@heroicons/react/24/solid";

export default function AvatarPictureUpload({
    defaultImageUrl,
    imageUrlParam, 
    imageAlt,
    onChange = (file) => {},
    onRemoveImage = () => {}
}) {
    const alert = useAlert();
    const uploadRef = useRef({});
    const [initialImageUrl, setInitialImageUrl] = useState(defaultImageUrl);
    const [imageUrl, setImageUrl] = useState(defaultImageUrl);
    useEffect(() => {
        if (defaultImageUrl && (defaultImageUrl !== initialImageUrl))
            setInitialImageUrl(defaultImageUrl);
        if (defaultImageUrl && !imageUrl)
            setImageUrl(defaultImageUrl);
    }, [defaultImageUrl]);
    useEffect(() => {
        if (typeof imageUrlParam === "object" && imageUrlParam.fileContents) {
            console.log("reading from file ")
            let fr = new FileReader();
            fr.onload = () => {
                setImageUrl(fr.result);
            };
            fr.readAsDataURL(imageUrlParam.fileContents);
        }
    }, [imageUrlParam]);
    function resetImage() {
        // setProduct({ ...product, image: undefined });
        onChange(undefined);
        setImageUrl(initialImageUrl);
    }
    function removeImage() {
        setImageUrl("");
        // setProduct({ ...product, image: undefined, logoFileKey: undefined });
        onRemoveImage();
    }
    return (
        <div
            className={"flex flex-col gap-4 justify-center content-center items-center"}
        >
            <span
                className="flex flex-row justify-center"
                onClick={() => uploadRef.current.click()}
            >
                {imageUrl ? (
                    <div className="relative w-3/4 xl:w-1/2 p-2 group cursor-pointer">
                        <span className="absolute top-0 right-0 z-50 hidden group-hover:inline p-2 -m-2 opacity-100"
                            onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    removeImage();
                                }}
                        >
                            <XMarkIcon 
                                className="w-6 text-white bg-red-700 rounded-full border-2 border-white" 
                                title="Remove Image"
                            />
                        </span>
                        <img
                            // id={"product-logo"}
                            alt={imageAlt}
                            src={imageUrl}
                            className="hover:opacity-70 z-10"
                        />
                    </div>
                ) : (
                    <DocumentArrowUpIcon className={"w-3/4 xl:w-1/2"} />
                )}
            </span>
        <input
            ref={uploadRef}
            className="hidden"
            type="file"
            onChange={(e) => {
            e &&
                e.target &&
                verifyFileTypeForUpload(
                constants.ALLOWED_IMAGE_TYPES_CSV,
                e.target.value,
                () =>
                    onChange({
                    fileName: e.target.files[0]?.name,
                    fileContents: e.target.files[0],
                    }),
                () =>
                    alert(
                    "Invalid File(s)",
                    `Only ${constants.ALLOWED_IMAGE_TYPES_CSV} files are permitted`,
                    "warning"
                    )
                );
            }}
            accept={constants.ALLOWED_IMAGE_TYPES_CSV}
        />
        {defaultImageUrl !== imageUrl && (
            <span onClick={resetImage}>
            <p className="hover:text-red-500 hover:cursor-pointer">
                Reset
            </p>
            </span>
        )}
        {/* {defaultImageUrl && defaultImageUrl === imageUrl && (
            <span onClick={removeImage}>
            <p className="hover:text-red-500 hover:cursor-pointer">
                Remove Image
            </p>
            </span>
        )} */}
        </div>
    )
}